import { EQUIPMENT } from '../../../../equipment'
import { getEquipmentExerciseUtil } from '../index'

function isBodyWeightExerciseUtil (exercise) {
  if (!exercise) {
    return
  }
  const equipment = getEquipmentExerciseUtil(exercise)
  return (
    equipment.length ===
    0 ||
    (
      equipment.length === 1 && equipment[0] === EQUIPMENT.BODYWEIGHT
    )
  )
}

export default isBodyWeightExerciseUtil
